import { Component } from 'react';
import moment from 'moment';
import {
  Card,
  CardContent,
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';

import NoDataLabel from '../../../../reporting/cards/common/NoDataLabel';
import { getInfluencerYoutubeAdStats } from '../../../../../api_handlers/reporting';
import {
  unwrapResponse,
  buildOverallRows,
  formatCell,
} from '../../../../reporting/cards/youtube/adStatsUtils';

class AdStats extends Component {
  constructor(props) {
    super(props);
    this.state = { rows: [], loading: true, error: null };
  }

  componentDidMount() {
    this.getData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.startDate !== this.props.startDate || prevProps.endDate !== this.props.endDate) {
      this.getData();
    }
  }

  async getData() {
    this.setState({ loading: true, error: null });

    try {
      const response = await getInfluencerYoutubeAdStats(
        this.props.campaignId,
        this.props.influencerId,
        this.props.startDate ? moment(this.props.startDate).format('YYYY-MM-DD') : null,
        this.props.endDate ? moment(this.props.endDate).format('YYYY-MM-DD') : null,
      );

      const payload = unwrapResponse(response);
      this.setState({ rows: buildOverallRows(payload.overall || payload), loading: false });
    } catch (error) {
      console.error('Failed to load influencer YouTube ad stats', error);
      this.setState({
        rows: [],
        loading: false,
        error: 'Could not load organic vs paid data for this creator.',
      });
    }
  }

  renderBody() {
    const { loading, error, rows } = this.state;

    if (loading) {
      return (
        <Grid container justify="center" style={{ padding: 24 }}>
          <CircularProgress size={24} />
        </Grid>
      );
    }

    if (error) {
      return <Grid container style={{ padding: '7px 0px', color: 'gray' }}>{error}</Grid>;
    }

    if (rows.length === 0) return <NoDataLabel offsetTop={10} />;

    return (
      <Table size="small" aria-label="creator organic versus paid">
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell align="right">Organic</TableCell>
            <TableCell align="right">Paid</TableCell>
            <TableCell align="right">Total</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.key}>
              <TableCell component="th" scope="row">
                {row.label}
              </TableCell>
              <TableCell align="right">{formatCell(row.organic, row.format)}</TableCell>
              <TableCell align="right">{formatCell(row.paid, row.format)}</TableCell>
              <TableCell align="right">{formatCell(row.total, row.format)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  }

  render() {
    return (
      <Card style={{ width: '100%' }}>
        <CardContent>
          <Grid container>
            <Grid item md={12} className="dashboard-card-title" style={{ paddingBottom: 10 }}>
              Organic Vs Paid
            </Grid>
            <Grid item md={12}>
              {this.renderBody()}
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  }
}

export default AdStats;
